module.exports = __webpack_public_path__ + "img/check-64.5ae162dd.png";